<script>
  import Main from "./Main.svelte";
  import * as firebase from "firebase/app";

  const initFirebase = async () => {
    const response = await fetch("/__/firebase/init.json");
    const config = await response.json();

    firebase.initializeApp({
      ...config,
      ...(location.hostname === "localhost"
        ? {
            databaseURL: "http://localhost:9000?ns=hallminhand"
          }
        : {})
    });
  };
</script>

{#await initFirebase() then _}
  <Main />
{/await}
